import React, { Component } from 'react';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class Handover extends Component {
    render() {
        return (
            <div className="document-content-container">
                <Breadcrumbs />
                <div className="document-content">
                    <h1 className="document-content-heading">Handover and Handback</h1>
                    <h2 className="document-content-subheading">Handover</h2>
                    <p className="document-info">
                        The Handover occurs when the Subscriber (or Service Aggregator) redirects the Cardholder
                        to the Designer Website (Standard or Gallery). The following parameters must be
                        provided in the URL:
                        </p>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Handover_Key</span> (GUID string)</p>
                            <p className="document-info">
                                uniquely identifies the Product (and respective card template) the Designer should
                                present to the Cardholder, for example:
                            </p>
                            <p className="document-info">https://...../AllAboutMe/Designer/PCS/Start.aspx?Handover_Key=af1bb313-749d-47f1-8c99-40f99a42f0d4</p>
                            <p className="document-info">https://...../AllAboutMe/Designer/PCS/Gallery.aspx?Handover_Key=af1bb313-749d-47f1-8c99-40f99a42f0d4</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Pass-through parameters</span> (optional)</p>
                            <p className="document-info">any non-reserved parameters can be added to the Handover. The Designer Website will
                                then include them in the Handover unaltered. </p>
                        </li>
                    </ul>
                    <p className="document-info"> The Service Aggregator can obtain the Handover URL(s) (including any required parameters)
                        for each Product by viewing the product details in the PCS administration site.
                        Both the URL and the value of any identifying parameters will be different on each
                            environment used during the project (Testing and Production).</p>
                    <p className="document-info">
                        The information that is passed to Thales in the Handover process only provides
                        the identity of the Service Aggregator, Subscriber and Product to the Designer Website,
                            which then drives which card template and gallery selections to show</p>
                    <p className="document-info">
                        These parameters are random strings, which have no relation to each other. This
                        means that Cardholders cannot easily edit the link to view another Aggregator, Subscriber
                        or Product. However if the identifying string is freely available on the internet
                        then it will be an &quot;open&quot; secret. In this case it will not matter as the Designer
                            Website would be available to the general public anyway</p>

                    <h2 className="document-content-subheading">Handback</h2>
                    <p className="document-info">
                        The Handback occurs once the Cardholder submits his card design (on the Preview
                        page). At that point, the Cardholder is redirected to the URL specified by the Subscriber
                        (for the Cardholder&#39;s Product). The Designer Website adds the following parameters
                            to the URL:</p>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">CardImageID</span> (string)</p>
                            <p className="document-info">A random, unique string that identifies the card design submitted by the Cardholder.
                            The string will have a fixed length of 9 alphanumeric characters (case insensitive).
                            This value should be stored by the Subscriber as it is required for all the web
                            service calls.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Handover_Key</span> (GUID string)</p>
                            <p className="document-info">The same value that was passed to the Designer Website in the Handover.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Pass-through parameters</span> (optional)</p>
                            <p className="document-info">Any non-reserved parameters passed to the Designer Website during the Handover will be passed along to the Handover unaltered.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Image Type</span> (string)</p>
                            <p className="document-info">States whether the card holder chose a gallery image or uploaded a custom image.</p>
                        </li>
                    </ul>

                </div>
            </div>
        )
    }
}

export default Handover;